var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        {
          directives: [
            {
              name: "touch",
              rawName: "v-touch:swipe.left",
              value: _vm.nextPage,
              expression: "nextPage",
              arg: "swipe",
              modifiers: { left: true }
            },
            {
              name: "touch",
              rawName: "v-touch:swipe.right",
              value: _vm.previousPage,
              expression: "previousPage",
              arg: "swipe",
              modifiers: { right: true }
            }
          ],
          class: {
            "d-flex": true,
            "justify-content-center": true,
            "my-5": !_vm.showingInForm,
            "my-4": _vm.showingInForm
          }
        },
        [
          _c(
            "b-col",
            { staticClass: "arrow-container", attrs: { cols: "1" } },
            [
              !_vm.$store.state.healthyHabits.predefinedHabit.hideLeftArrow
                ? _c("b-icon-caret-left", {
                    staticClass: "arrow-left-predefined",
                    attrs: { scale: "1.4" },
                    on: { click: _vm.previousPage }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.itemsToShow, function(item, index) {
            return _c(
              "b-col",
              {
                key: "habit-predefined-" + index,
                staticClass: "d-flex justify-content-center",
                attrs: {
                  cols: "5",
                  sm: _vm.showingInForm ? 5 : 3,
                  md: _vm.showingInForm ? 3 : 5,
                  xl: "3"
                }
              },
              [
                _c(
                  "base-card",
                  {
                    class: {
                      "card-predefined": true,
                      "predefined-selected":
                        item.id ===
                        _vm.$store.state.healthyHabits.predefinedHabit
                          .itemIdSelected
                    },
                    style: { "z-index": _vm.boxPredefinedZIndex(index) },
                    on: {
                      click: function($event) {
                        return _vm.predefinedHabitSelected(item)
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "card-predefined-description" }, [
                      _vm._v(_vm._s(item.description))
                    ])
                  ]
                )
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "arrow-container", attrs: { cols: "1" } },
            [
              !_vm.$store.state.healthyHabits.predefinedHabit.hideRightArrow
                ? _c("b-icon-caret-right", {
                    staticClass: "arrow-right-predefined",
                    attrs: { scale: "1.4" },
                    on: { click: _vm.nextPage }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-102d2373", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-102d2373","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/healthy-habits/HealthyHabitsPredefined.vue
// module id = 1721
// module chunks = 116